import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DepartamentoService } from '../../departamento/departamento.service';
import { EnvioService } from '../../envio/envio.service';
import { Interceptor } from '../../../token/interceptor';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class SharedNotificacionModule {

  static forRoot(): ModuleWithProviders<SharedNotificacionModule> {
    return {
      ngModule: SharedNotificacionModule,
      providers: [
        DepartamentoService, EnvioService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true
        }]
    };
  }
}
